import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = () => {
  const { isAuthenticated, loading, staff } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (staff?.portal && staff?.subject) {
    const path = location?.pathname || '';
    const m = path.match(/^\/devotees\/([^/]+)/);
    if (m && String(m[1]) !== String(staff.subject)) {
      return <Navigate to={`/devotees/${staff.subject}/home`} replace />;
    }
  }

  return <Outlet />;
};

export default PrivateRoute;
